// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__CiZ3T","productName":"Table_productName__telY6"};